// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("core.ruffle." + {"110":"052538f9825bb365711c","993":"402a565a775aaabcf236"}[chunkId] + ".js");